import { render, staticRenderFns } from "./AcademyStudent.vue?vue&type=template&id=bcee9294&scoped=true&"
import script from "./AcademyStudent.vue?vue&type=script&lang=js&"
export * from "./AcademyStudent.vue?vue&type=script&lang=js&"
import style0 from "./AcademyStudent.vue?vue&type=style&index=0&id=bcee9294&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcee9294",
  null
  
)

export default component.exports